import sanitizeHtml from 'sanitize-html'

export const getSanitizedHtml = text => {
  return sanitizeHtml(text, {
    allowedTags: ['strong', 'a', 'em'],
    allowedAttributes: {
      a: ['href', 'target']
    }
  })
}



// WEBPACK FOOTER //
// ./client/utils/sanitizeHtml.js